export enum ChatReceiverTypeEnum {
  User = '00000209-1000-0000-0000-000000000001',
  Room = '00000209-1000-0000-0000-000000000002'
}
